export type FormColourTheme = 'light' | 'dark';

export interface FormThemeProps {
  inputColour: string;
  inputBackground: string;
  textColour: string;
  borderColour: string;
  errorColour: string;
  containerColour: string;
  checkboxBorderColour: string;
  checkboxIcon: string;
  actionColour: string;
}

export const theme = {
  light: {
    inputColour: '--colour-deep-space-700',
    inputBackground: '--colour-white',
    textColour: '--colour-inverse-subtle-dark-text',
    borderColour: '--colour-border-base',
    errorColour: '--colour-error-rgb',
    containerColour: '--colour-white',
    checkboxBorderColour: '--colour-border-strong',
    actionColour: '--colour-ultraviolet',
    checkboxIcon: 'Check.svg',
  },
  dark: {
    inputColour: '--colour-inverse-base',
    inputBackground: '--colour-inverse-subtle',
    textColour: '--colour-inverse-subtle-text',
    borderColour: '--colour-border-inverse-base',
    errorColour: '--colour-text-inverse-error-rgb',
    containerColour: '--colour-surface-inverse-strong',
    checkboxBorderColour: '--colour-border-inverse-strong',
    actionColour: '--colour-inverse-action',
    checkboxIcon: 'check-deep-space.svg',
  },
};
